// @flow weak

import { appConfig } from '../../config';
import {
  checkStatus,
  parseJSON,
  loginHeader,
  imageHeader,
  postMethod,postFormMethod
} from '../fetchTools';
import axios from 'axios';

export const authUser = async (req) => {
  const url = `${appConfig.BASE_API}/login2`;
  const options = { ...postMethod, ...loginHeader, body: JSON.stringify(req) };
  
  try {
    var response = await fetch(url, options);
    // var status = await checkStatus(response);
    // var json = await parseJSON(response);
    var data = await response.text()
    try {
      data = JSON.parse(data)
    } catch (error) {
      
    }
    return data;
  } catch (error) {
    // console.log('error', error)
    return null;
  }
  
};
export const register = async (req) => {
  const url = `${appConfig.BASE_API}/registerr`;
  // const options = { ...postMethod, ...loginHeader, body: JSON.stringify(req) };
  
  try {
    var {status, data} = await axios({url:url,method:'post', data:req,headers:loginHeader});
    // var status = await checkStatus(response);
    // var json = await parseJSON(response);
    return {status, data};
  } catch (error) {
    /*console.log('error', error)*/
    return null;
  }
  
};
export const registerimage = async (imageFile) => {
  const url = `${appConfig.BASE_API}/image/register`;
  var bodyFormData = new FormData();
  bodyFormData.append('file', imageFile,'sticker.jpg'); 
  // console.log('imagefile',imageFile)
  // console.log('formdata',bodyFormData)
  // const options = { ...postFormMethod, ...imageHeader, data: bodyFormData };
  
  try {
    var response = await axios({url:url,method:'post', data:bodyFormData,headers:imageHeader});
    // var status = await checkStatus(response);
    // var json = await parseJSON(response);
    return response;
  } catch (error) {
    /*console.log('error', error)*/
    return null;
  }
  
};

export const registerAccount = async (imageFile, data) => {
  const url = `${appConfig.BASE_API}/new_registerr`;
  var bodyFormData = new FormData();
  bodyFormData.append('file', imageFile);  
  bodyFormData.append('data', data);  
  try {
    var response = await axios({url:url,method:'post', data:bodyFormData,headers:imageHeader});
    return response;
  } catch (error) {
    return null;
  }
};

export const refreshToken = async (req) => {
  console.log('refreshToken req :: ', req);
  const url = `${appConfig.BASE_API}/refreshtoken`;
  const options = { ...postMethod, ...loginHeader, body: JSON.stringify(req) };
   // console.log(url,options)
  try {
    var response = await axios({url:url, method:'post',data:req, headers:loginHeader});
    console.log('refreshToken response :: ', response)
    // var data = await response.text()
    //  console.log('response refresh', data)
    // var status = await checkStatus(response);
    // var refreshstatus = await status.text()
    // console.log('status refresh', refreshstatus)
    // var json = await parseJSON(response);
    // // console.log('json', json)
    return response;
  } catch (error) {
    console.log('refreshtoken error',error)
    return response.status;
  }
}

export const authDelivery = async (req) => {
  const url = `${appConfig.iSupport_URL}/loginDelivery`;
  const options = { ...postMethod, ...loginHeader, body: JSON.stringify(req) };
  
  try {
    var response = await fetch(url, options);
    var data = await response.text()
    try {
      data = JSON.parse(data)
    } catch (error) {
      
    }
    return data;
  } catch (error) {
    // console.log('error', error)
    return null;
  }
  
};

export const getReceiptImage2 = async (fileName, token) => {
  try 
  {
    console.log('P filename : ', fileName)
    console.log('P token : ', token)
    const response = await axios.get(`${appConfig.iSupport_URL}/binn/dlv/${fileName}`, {
      
      responseType: 'blob', headers :{
        Accept: 'application/json',
        'Content-Type' : 'application/json',
        'Authorization' :'Bearer '+ token
      }
    })

    const data = await response.data
    const dataUrl = URL.createObjectURL(data)

    // console.log('IMG data: ',data)
    // console.log('IMG dataUrl: ',dataUrl)
    return {status: response.status, data: dataUrl}
  } catch (error) {
    // if (error.response){
    //     return { status: error.response.status, data: error.response.data }
    // }
    // console.log('error',error)
    return { status: error.code, message: error.message }
  }
}

export const getReceiptImage = async (fileName, token) => {
  try {
    var dataImage = null
      const response = await fetch(`${appConfig.iSupport_URL}/binn/dlv/${fileName}`,
        {
            method: 'GET', 
            responseType: 'blob', 
            headers :{
              Accept: 'application/json',
              'Content-Type' : 'application/json',
              'Authorization' :'Bearer '+ token
            }
          }
      )
      .then(response => response.blob())
      .then(blob => {
        dataImage = URL.createObjectURL(blob)
        console.log('dataaaa',dataImage)
        
      })

      // fetch(`${appConfig.iSupport_URL}/image/tmp/${fileName}`, {
      //   method: 'GET', 
      //   responseType: 'blob', 
      //   headers :{
      //     Accept: 'application/json',
      //     'Content-Type' : 'application/json',
      //     'Authorization' :'Bearer '+ token
      //   }
      // })
      //console.log('IMG RESI response : ',response)

      //console.log('IMG RESI response.url : ', response.url)
      // const dt = await response.json();
      // console.log('aaaa dt : ', dt)
      
      //const data = await response.body
      //const dataUrl = URL.createObjectURL(response.url)
      return dataImage
  } catch (error) {
      return { status: error.code, message: error.message }
  }


}   


export const privacyNoticeUpdate = async (tmpToken) => {
  const url = `${appConfig.BASE_API}/privacyNotice`;
  const options = { ...postMethod, headers: {
    Accept: 'application/json',
    'Content-Type' : 'application/json',
    'Authorization' :'Bearer '+ tmpToken
  }};
  
  try {
    var response = await fetch(url, options);
    var data = await response.text()
    try {
      data = JSON.parse(data)
    } catch (error) {
      
    }
    return data;
  } catch (error) {
    return null;
  }
};
